import Vue, { App } from 'vue'
import SvgPlugin from './src'

export default function (app: App) {
  app.use(SvgPlugin, {})
}
